import { matchValueToOption } from './matchSuggestionToOption';
import {
  CheckboxesBlock,
  CheckboxesBlockValue,
} from 'concepts/Extraction/Blocks/Checkboxes/CheckboxesBlock';
import { getInitialCheckboxesBlockValue } from 'concepts/Extraction/Blocks/Checkboxes/utils';

export type CheckboxesMatchResult = {
  suggestedValue: CheckboxesBlockValue;
  matchedOptionIds: string[];
  unmatchedValues: string[];
} | null;

export const matchSuggestionToCheckboxOptions = (
  suggestion: string | null,
  block: CheckboxesBlock,
  autoDocExtField: string
): CheckboxesMatchResult => {
  if (!suggestion) return null;

  // Multi-value suggestions joined with "; "
  // are split into individual values for matching against the block's options
  const values = suggestion
    .split('; ')
    .map((value) => value.trim())
    .filter(Boolean);

  const matchedOptionIds: string[] = [];
  const unmatchedValues: string[] = [];

  values.forEach((value) => {
    const matched = matchValueToOption(value, block.options, autoDocExtField);

    if (matched) {
      if (!matchedOptionIds.includes(matched.id)) {
        matchedOptionIds.push(matched.id);
      }
      return;
    }

    const normalised = value.replace(/;/g, '|').trim();
    if (normalised && !unmatchedValues.includes(normalised)) {
      unmatchedValues.push(normalised);
    }
  });

  if (unmatchedValues.length > 0 && block.otherOption === null) {
    return null;
  }

  if (matchedOptionIds.length === 0 && unmatchedValues.length === 0) {
    return null;
  }

  const suggestedValue = getInitialCheckboxesBlockValue(block.options, {
    options: Object.fromEntries(matchedOptionIds.map((id) => [id, true])),
    ...(unmatchedValues.length > 0 && {
      otherOption: { selected: true, value: unmatchedValues.join(' | ') },
    }),
  });

  return { suggestedValue, matchedOptionIds, unmatchedValues };
};
